export default __webpack_public_path__ + "static/media/event-sport-bg.51fcee37.webp";